import { subDays } from 'date-fns';
import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { bind, InputDropdownMultiSelectFilter } from 'Mri.Web.Common';
import * as React from 'react';
import { Input, Label } from 'reactstrap';
import { DisplayListViewModel } from './DisplayListViewModel';

export interface IWhereClause {
    option: string;
    value: string;
}
export interface IWhereFilterProps {
    readonly vm: DisplayListViewModel;
}

@observer
export class WhereFilter extends React.Component<IWhereFilterProps> {
    public render() {
        const { where, onFilterDropdownToggle } = this.props.vm;

        return (
            <InputDropdownMultiSelectFilter
                title="Filters"
                extraSelecteditems={this.selectedItems}
                filter={where}
                options={this.options}
                style={{
                    minWidth: 400,
                }}
                print={this.print}
                onToggle={onFilterDropdownToggle}
                onChange={this.onChange}
                openOnMount
            >
                <div key="active" className="px-1">
                    <Label check className="m-1">
                        <Input
                            type="checkbox"
                            checked={this.activeState == true}
                            onChange={() => this.onActiveChange(true)}
                        />{' '}
                        Active
                    </Label>
                </div>
                <div key="inactive" className="px-1">
                    <Label check className="m-1">
                        <Input
                            type="checkbox"
                            checked={this.activeState == false}
                            onChange={() => this.onActiveChange(false)}
                        />{' '}
                        Inactive
                    </Label>
                </div>
                <div key="activeInactive" className="px-1">
                    <Label check className="m-1">
                        <Input
                            type="checkbox"
                            checked={this.activeState == null}
                            onChange={() => this.onActiveChange(null)}
                        />{' '}
                        Active + Inactive
                    </Label>
                </div>
            </InputDropdownMultiSelectFilter>
        );
    }

    @action
    public componentWillUnmount() {
        this.onChange(undefined);
    }

    @bind
    private onChange(value: IWhereClause[] | undefined) {
        this.props.vm.where = value;
    }

    @bind
    @action
    private onActiveChange(activeState: boolean | null) {
        const { displayFilter } = this.props.vm;
        displayFilter.active = activeState;
    }

    @computed
    private get activeState() {
        const { displayFilter } = this.props.vm;

        return displayFilter.active;
    }

    @computed
    private get selectedItems() {
        if (this.activeState) return 'Active';
        else if (this.activeState == false) return 'Inactive';
        else if (this.activeState == null) return 'Active & Inactive';
    }

    @bind
    private print(entity: IWhereClause) {
        return entity.option;
    }

    private recentlyShippedDate = subDays(new Date(), 90);

    // Value is a Linq.Dynamic query string determined by Mri.Pultt.Actors.SortedDisplayFilterActor.FilterableDisplay
    private options: IWhereClause[] = [
        {
            option: 'Tour',
            value: 'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Good" && ActiveDisplayStatus?.DisplayStatus=="Online"',
        },
        { option: 'Critical', value: 'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Critical"' },
        { option: 'Warning', value: 'ActiveDisplayStatus?.LastKnownPoll?.DisplayHealth=="Warning"' },
        {
            option: 'No Connection',
            value: [
                'ActiveDisplayStatus?.DisplayStatus=="TimedOut"',
                'ActiveDisplayStatus?.DisplayStatus=="NeverCommunicated"',
                'ActiveDisplayStatus?.DisplayStatus=="NocCouldNotConnect"',
            ].join(' || '),
        },
        {
            option: 'Online',
            value: 'ActiveDisplayStatus?.DisplayStatus=="Online"',
        },
        {
            option: 'Has Support Tickets',
            value: 'OpenTicketCount>0',
        },
        {
            option: 'Recently Shipped (90 Days)',
            value: `ShippedDate>DateTime(${this.recentlyShippedDate.getFullYear()},${this.recentlyShippedDate.getMonth()},${this.recentlyShippedDate.getDay()})`,
        },
        {
            option: 'Infinite Touch',
            value: `ActiveDisplayStatus?.LastKnownPoll?.DisplayStatusPoll?.SigmaSense?.TouchScreens!=null`,
        },
    ];
}
